module.exports = __webpack_public_path__ + "img/rugbyunion.2180da07.svg";